export default function LinkedInIcon({ width = 22, height = 22, className, style }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 26 26"
            fill="none"
            className={className}
            style={style}
            aria-hidden="true"
        >
            <rect width="26" height="26" rx="5" fill="#EAEAEA" />
            <path
                d="M23.6481 0H2.35191C1.053 0 0 1.053 0 2.35191V23.648C0 24.947 1.053 26 2.35191 26H23.648C24.947 26 26 24.947 26 23.648V2.35191C26 1.053 24.947 0 23.6481 0ZM8.0455 22.4501C8.0455 22.8281 7.73908 23.1346 7.36106 23.1346H4.44757C4.06954 23.1346 3.76313 22.8281 3.76313 22.4501V10.2369C3.76313 9.85883 4.06954 9.55241 4.44757 9.55241H7.36106C7.73908 9.55241 8.0455 9.85883 8.0455 10.2369V22.4501ZM5.90431 8.40113C4.37569 8.40113 3.13647 7.16191 3.13647 5.63329C3.13647 4.10466 4.37569 2.86544 5.90431 2.86544C7.43294 2.86544 8.67216 4.10466 8.67216 5.63329C8.67216 7.16191 7.43301 8.40113 5.90431 8.40113ZM23.2714 22.5052C23.2714 22.8528 22.9896 23.1346 22.6421 23.1346H19.5157C19.1681 23.1346 18.8863 22.8528 18.8863 22.5052V16.7765C18.8863 15.9219 19.137 13.0316 16.653 13.0316C14.7262 13.0316 14.3354 15.01 14.2569 15.8978V22.5052C14.2569 22.8528 13.9752 23.1346 13.6276 23.1346H10.6038C10.2563 23.1346 9.97454 22.8528 9.97454 22.5052V10.1817C9.97454 9.83419 10.2563 9.55241 10.6038 9.55241H13.6276C13.9751 9.55241 14.2569 9.83419 14.2569 10.1817V11.2472C14.9714 10.1751 16.0332 9.34748 18.2939 9.34748C23.3 9.34748 23.2714 14.0245 23.2714 16.5943V22.5052Z"
                fill="#0077B7"
            />
        </svg>
    );
}
